import { bffService, config, DistanceUnit, ecomService } from '@thisisdevelopment/akzonobel-core';

export const tagManagerArgs = {
  gtmId: 'GTM-KTGQRMH',
};

export const init = () => {
  const ecomURL = process.env.NEXT_PUBLIC_ECOM_URL;

  config.googleApiKey = `${process.env.NEXT_PUBLIC_GOOGLE_API_KEY}`;
  config.bugsnagApiKey = `${process.env.NEXT_PUBLIC_BUGSNAG_API_KEY}`;
  config.sprinklrEnabledHome = false;
  config.sprinklrEnabledColor = false;
  config.showCookieSettings = true;
  config.sprinklrClientId = '';
  config.sprinklrEmbedId = '';
  config.domainCode = `${process.env.NEXT_PUBLIC_DOMAIN_CODE}`;
  config.channel = `${process.env.NEXT_PUBLIC_CHANNEL}`;
  config.language = `${process.env.NEXT_PUBLIC_LANGUAGE}`;
  config.distanceUnit = DistanceUnit.Imperial;
  config.cartUrl = `${ecomURL}/cart`;
  config.ecomEnabled = false;
  config.hasSubBar = false;
  config.subBarHeight = 40;
  config.socials = {
    instagram: 'https://www.instagram.com/duluxheritageireland',
  };
  config.relatedSites = [
    {
      url: 'https://www.dulux.ie',
      title: 'Dulux',
    },
    {
      url: 'https://www.cuprinol.ie/index.jsp',
      title: 'Cuprinol',
    },
    {
      url: 'http://www.hammerite.ie',
      title: 'Hammerite',
    },
    {
      url: 'https://www.weathershield.ie',
      title: 'Weathershield',
    },
    {
      url: 'https://www.duluxtradepaintexpert.ie',
      title: 'Dulux Trade Paint Expert',
    },
  ];
  config.menuItems = [
    { label: 'The Heritage Story', to: '/en/the-heritage-story' },
    {
      label: 'Find your paint',
      items: [
        { label: 'Our colours', to: '/en/colours' },
        { label: 'Our products', to: '/en/products' },
      ],
    },
    {
      label: 'Inspiration and Advice',
      items: [
        { label: 'Ideas', to: '/en/inspiration/category/ideas' },
        {
          label: 'Practical help',
          to: '/en/inspiration/category/practical-help',
        },
      ],
    },
    { label: 'For Professionals', to: '/en/for-professionals' },
    { label: 'Stockists', to: '/en/stores' },
  ];
  config.enableChangeLights = true;
  bffService.initAxiosConfig(`${process.env.NEXT_PUBLIC_BFF_URL}`);
  ecomService.initAxiosInstance(`${ecomURL}/api`);
};

export const pageRevalidate = parseInt(process.env.PAGE_REVALIDATE ?? '86400');

export const tryDifferentLightsId = 'try-different-lights';
